import { initialAppliedDiscounts, initialSpecs, initialState } from './state'

const SET_SPECS = (state, specs) => {
  state.specs = { ...state.specs, ...specs }
}

const SET_DISCOUNT = (state, discount) => {
  state.specs = {
    ...state.specs,
    discounts: { ...state.specs.discounts, ...discount },
  }
}

const RESET_ASSET_DISCOUNTS_IF_UNSELECTED = (state) => {
  const hasBattery = (state.specs.assets || []).some(
    (a) => a.type === 'battery' && a.amount > 0
  )
  const hasEvCharger = (state.specs.assets || []).some(
    (a) => a.type === 'evCharger' && a.amount > 0
  )
  const discounts = { ...state.specs.discounts }
  if (!hasBattery) discounts.battery = 0
  if (!hasEvCharger) discounts.evCharger = 0
  state.specs = { ...state.specs, discounts }
}

const SET_SIMULATION = (state, simulation) => {
  state.simulation = simulation
}

const SET_LAST_SIMULATED_PANELS = (state, panels) => {
  state.lastSimulatedPanels = panels
}

const SET_INSTALLATION_TAX = (state, installationTax) => {
  state.installationTax = installationTax
}

const SET_TAX_TYPE = (state, taxType) => {
  state.taxType = taxType
}

const SET_ASSETS_CATALOG = (state, assetsCatalog) => {
  state.assetsCatalog = assetsCatalog
}

const SET_IS_LOADING_CATALOG = (state, isLoading) => {
  state.isLoadingCatalog = isLoading
}

const SET_CATALOG_ERROR = (state, hasError) => {
  state.catalogError = hasError
}

const SET_IS_LOADING = (state, isLoading) => {
  state.isLoading = isLoading
}

const SET_ERROR = (state, error) => {
  state.error = error
}

const SET_APPLIED_DISCOUNTS = (state, discounts) => {
  state.appliedDiscounts = {
    ...initialAppliedDiscounts,
    ...(discounts || {}),
  }
}

const SET_IS_APPLYING_DISCOUNT = (state, value) => {
  state.isApplyingDiscount = Boolean(value)
}

const SET_APPLY_DISCOUNT_ERROR = (state, error) => {
  state.applyDiscountError = error
}

const RESET_STATE = (state) => {
  Object.assign(state, {
    ...initialState,
    specs: { ...initialSpecs },
    appliedDiscounts: { ...initialAppliedDiscounts },
  })
}

export default {
  SET_SPECS,
  SET_DISCOUNT,
  RESET_ASSET_DISCOUNTS_IF_UNSELECTED,
  SET_SIMULATION,
  SET_LAST_SIMULATED_PANELS,
  SET_INSTALLATION_TAX,
  SET_TAX_TYPE,
  SET_ASSETS_CATALOG,
  SET_IS_LOADING_CATALOG,
  SET_CATALOG_ERROR,
  SET_IS_LOADING,
  SET_ERROR,
  SET_APPLIED_DISCOUNTS,
  SET_IS_APPLYING_DISCOUNT,
  SET_APPLY_DISCOUNT_ERROR,
  RESET_STATE,
}
